import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { makeGetSummaryOrder } from '../../lib/selector';

import PerfectScrollBar from 'react-perfect-scrollbar';
import { Col } from 'react-bootstrap';

import {
  numberFormat,
  _convertTpToPrice,
  _getOrderStatus,
  mapOrderChanel,
  _formatDate2,
} from '../../utils';

import Page from '../print/Page';
import PrintButton from '../print/PrintButton';
import FormSearchSKL from './layout/formSearchSKL';
import Paging from '../paging';

import logo from '../../assets/img/logo.png';

import { take, takeRight } from 'lodash';

import ExportSaoKeSoLenh from '../../lib/exports/SaoKeSoLenh';
import { translate } from 'react-i18next';
class SaoKeSoLenh extends React.Component {
  state = {
    contentShow: [],
    // paging
    continued: false,
    totalCount: 0,
    page: 1,

    params: null,
  };

  componentDidUpdate(preProps) {
    const { listOrder } = this.props;

    if (listOrder && listOrder !== preProps.listOrder) {
      this.setState({ totalCount: listOrder.list ? listOrder.list.length : 0 });
      this.handleQueryPage(1);
    }
  }

  handleQueryPage = (page) => {
    const pageSize = 15;
    const { listOrder } = this.props;
    if (!listOrder || !listOrder.list) return;
    const _totalPage = Math.ceil(listOrder.list.length / pageSize);

    const _takeContent = take(listOrder.list, pageSize * page);
    const _contentShow = takeRight(
      _takeContent,
      _takeContent.length - pageSize * (page - 1)
    );
    console.log(_contentShow);
    this.setState({
      contentShow: _contentShow,
      page,
      continued: page < _totalPage,
    });
  };

  _saveParams = (params) => {
    // console.log(params)
    this.setState({ params });
  };

  render() {
    const { account, listOrder, t } = this.props;

    const { contentShow, params } = this.state;
    // console.log(account, params);
    return (
      <Fragment>
        <PerfectScrollBar style={{ height: 'calc( 100% - 50px )' }}>
          <div className="d-flex">
            <Col className="d-flex flex-column">
              <div className="d-flex flex-row mt-3 mb-2">
                <span
                  className="text-white mx-auto"
                  style={{ fontSize: '18px' }}
                >
                  {t('txt-label-order-history')}
                </span>
              </div>
              <FormSearchSKL account={account} saveParams={this._saveParams} />
              <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
                <label className="text-white ml-2 fz-14 text-uppercase">
                  {t('txt-detail')}
                </label>
                <div className="d-flex align-items-baseline">
                  <ExportSaoKeSoLenh
                    csvData={listOrder ? listOrder.list : []}
                    fileName="sao-ke-so-lenh"
                    fromDate={params && _formatDate2(params.data.fromDate)}
                    toDate={params && _formatDate2(params.data.toDate)}
                    symbol={params && (params.data.symbol || t('txt-all'))}
                    typeOrder={
                      params &&
                      (params.data.buySelTp === 'S'
                        ? t('txt-sell')
                        : params.data.buySelTp === 'B'
                        ? t('txt-buy')
                        : t('txt-all'))
                    }
                    accountCode={account && account.subAcntNo}
                    accountName={account && account.vsdAcntNo}
                  />
                  <PrintButton id={'sao-ke-giao-dich'} />
                </div>
              </div>
              <Page id="sao-ke-so-lenh">
                <table className="table table-bordered tbl-list">
                  <thead>
                    <tr>
                      <th className="text-center">{t('txt-stt')}</th>
                      <th className="text-center">
                        {t('txt-label-tran-date')}
                      </th>
                      <th className="text-center">{t('txt-trade-acronym')}</th>
                      <th className="text-center">{t('txt-symbol')}</th>
                      <th className="text-center">{t('txt-vol')}</th>
                      <th className="text-center">{t('txt-price')}</th>
                      <th className="text-center">{t('txt-match-vol')}</th>
                      <th className="text-center">{t('txt-match-price')}</th>
                      <th className="text-center">{t('txt-cancel-vol')}</th>
                      <th className="text-center">
                        {t('txt-total-match-value')}
                      </th>
                      {/* <th className="text-right">{t('txt-label-fee')}</th> */}
                      <th className="text-center">{t('txt-status')}</th>
                      <th className="text-center">{t('txt-type')}</th>
                      <th className="text-center">{t('txt-order-no')}</th>
                      <th className="text-center">
                        {t('txt-origin-order-no')}
                      </th>
                      <th className="text-center">{t('txt-label-channel')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contentShow &&
                      !!contentShow.length &&
                      contentShow.map((item, i) => {
                        if (item.modiCnclTp === '3') return null;
                        return (
                          <tr key={i}>
                            <td className="text-center">
                              {15 * (this.state.page - 1) + i + 1}
                            </td>
                            <td className="text-center">{item.wrkTime}</td>
                            <td className="text-center">
                              <div
                                className={
                                  'text-uppercase mx-auto trade_side_' +
                                  item.buySelTp
                                }
                              >
                                {item.buySelTp === '1'
                                  ? t('txt-buy')
                                  : t('txt-sell')}
                              </div>
                            </td>
                            <td className="text-center">{item.symbol}</td>
                            <td className="text-right">
                              {numberFormat(item.ordrQty, 0, '0')}
                            </td>
                            <td className="text-right">
                              {numberFormat(item.ordrUntprc, 0, '0')}
                            </td>
                            <td className="text-right">
                              {numberFormat(item.matchedQty, 0, '0')}
                            </td>
                            <td className="text-right">
                              {numberFormat(item.matchedPrc, 0, '0')}
                            </td>
                            <td className="text-right">
                              {numberFormat(item.ordrRemnQty, 0, '0')}
                            </td>
                            <td className="text-right">
                              {numberFormat(item.matchedAmt, 0, '0')}
                            </td>
                            {/* <td className="text-right">
                              {numberFormat(item.ordrFee, 0, '0')}
                            </td> */}
                            <td
                              className={
                                'text-center ordStt_' + item.ordrStatTp
                              }
                            >
                              {_getOrderStatus(
                                item.ordrStatTp,
                                item.ordrQty,
                                item.matchedQty
                              )}
                            </td>
                            <td className="text-center">
                              {_convertTpToPrice(item.ordrTrdTp)}
                            </td>
                            <td className="text-center">{item.ordrNo}</td>
                            <td className="text-center">{item.origOrdrNo}</td>
                            <td className="text-center">
                              {mapOrderChanel(item.ordrChnl)}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                {(!contentShow || !contentShow.length) && (
                  <p className="text-center fz-14 mt-2 title-time">
                    {t('txt-no-data-found')}
                  </p>
                )}
              </Page>
              {listOrder && (
                <Paging
                  handleQueryPage={this.handleQueryPage}
                  continued={this.state.continued}
                  totalCount={this.state.totalCount}
                  pageSize={15}
                  page={this.state.page}
                />
              )}
              <Page id="sao-ke-giao-dich" style={{ display: 'none' }}>
                <div className="d-flex flex-column bg-light">
                  <div
                    className="position-relative d-flex justify-content-center align-items-center"
                    style={{ height: '75px' }}
                  >
                    <img
                      src={logo}
                      alt="logo"
                      className="position-absolute"
                      style={{ top: '0', left: '0' }}
                    />
                    <span className="fz-18 font-weight-bold text-uppercase">
                      {'SAO KÊ GIAO DỊCH'}
                    </span>
                  </div>
                  <div className="d-flex mt-2">
                    <Col className="d-flex flex-column">
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Tên BC:'}</span>
                        <span className="fz-14 f_i">{'Sao kê giao dịch'}</span>
                      </div>
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Số tiểu khoản:'}</span>
                        <span className="fz-14 f_i">
                          {account && account.subAcntNo}
                        </span>
                      </div>
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Số VSD:'}</span>
                        <span className="fz-14 f_i">
                          {account && account.vsdAcntNo}
                        </span>
                      </div>
                    </Col>
                    <Col className="d-flex flex-column">
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Từ ngày:'}</span>
                        <span className="fz-14 f_i">
                          {params && _formatDate2(params.data.fromDate)}
                        </span>
                      </div>
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Đến ngày:'}</span>
                        <span className="fz-14 f_i">
                          {params && _formatDate2(params.data.toDate)}
                        </span>
                      </div>
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Mã CK:'}</span>
                        <span className="fz-14 f_i">
                          {params && (params.data.symbol || 'Tất cả')}
                        </span>
                      </div>
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Loại GD:'}</span>
                        <span className="fz-14 f_i">
                          {params &&
                            (params.data.buySelTp === 'S'
                              ? 'Bán'
                              : params.data.buySelTp === 'B'
                              ? 'Mua'
                              : 'Tất cả')}
                        </span>
                      </div>
                    </Col>
                  </div>
                </div>
                <div className="d-flex bg-light">
                  <table className="table table-bordered mt-2 table-light">
                    <thead>
                      <tr>
                        <th className="text-center">{'STT'}</th>
                        <th className="text-left">{'Thời gian GD'}</th>
                        <th className="text-left">{'GD'}</th>
                        <th className="text-left">{'Mã CK'}</th>
                        <th className="text-right">{'KL đặt'}</th>
                        <th className="text-right">{'Giá đặt'}</th>
                        <th className="text-right">{'KL khớp'}</th>
                        <th className="text-right">{'Giá khớp'}</th>
                        <th className="text-right">{'KL huỷ'}</th>
                        <th className="text-right">{'Tổng GT khớp'}</th>
                        <th className="text-left">{'Trạng thái'}</th>
                        <th className="text-left">{'Loại lệnh'}</th>
                        <th className="text-left">{'SHL'}</th>
                        <th className="text-left">{'SHL gốc'}</th>
                        <th className="text-left">{'Kênh GD'}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listOrder &&
                        listOrder.list &&
                        !!listOrder.list.length &&
                        listOrder.list.map((item, i) => {
                          if (item.modiCnclTp === '3') return null;
                          return (
                            <tr key={i}>
                              <td className="text-center">{i + 1}</td>
                              <td className="text-left">{item.wrkTime}</td>
                              <td className="text-left">
                                <div className={'trade_side_' + item.buySelTp}>
                                  {item.buySelTp === '1' ? 'MUA' : 'BÁN'}
                                </div>
                              </td>
                              <td className="text-left">{item.symbol}</td>
                              <td className="text-left">
                                {numberFormat(item.ordrQty, 0, '0')}
                              </td>
                              <td className="text-right">
                                {numberFormat(item.ordrUntprc, 0, '0')}
                              </td>
                              <td className="text-right">
                                {numberFormat(item.matchedQty, 0, '0')}
                              </td>
                              <td className="text-right">
                                {numberFormat(item.matchedPrc, 0, '0')}
                              </td>
                              <td className="text-right">
                                {numberFormat(item.ordrRemnQty, 0, '0')}
                              </td>
                              <td className="text-right">
                                {numberFormat(item.matchedAmt, 0, '0')}
                              </td>
                              {/* <td className="text-right">
                                {numberFormat(item.ordrFee, 0, '0')}
                              </td> */}
                              <td
                                className={
                                  'text-left ordStt_' + item.ordrStatTp
                                }
                              >
                                {_getOrderStatus(
                                  item.ordrStatTp,
                                  item.ordrQty,
                                  item.matchedQty
                                )}
                              </td>
                              <td className="text-left">
                                {_convertTpToPrice(item.ordrTrdTp)}
                              </td>
                              <td className="text-left">{item.ordrNo}</td>
                              <td className="text-left">{item.origOrdrNo}</td>
                              <td className="text-left">
                                {mapOrderChanel(item.ordrChnl)}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </Page>
            </Col>
          </div>
        </PerfectScrollBar>
      </Fragment>
    );
  }
}

const makeMapStateToProps = () => {
  const getSummaryOrder = makeGetSummaryOrder();

  const mapStateToProps = (state, props) => {
    return {
      listOrder: getSummaryOrder(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(SaoKeSoLenh)
);
